export const AUTHENTICATE = `
query Authenticate($password: String!) {
  auth(password: $password) {
    token
  }
}`

export const DIARIES = `
query {
  diaries {
    id
    key
    title
    category
    tags
    published
    created_at
    updated_at
    image {
      key
      url
      meta {
        title
        location
      }
    }
  }
}`

export const DIARY = `
query fetchDiary($key: String!){
  diary(key: $key) {
    id
    key
    title
    category
    published
    description
    medium
    links
    tags
    created_at
    updated_at
    content {
      page
      sections {
        type: __typename
        ... on Markdown {
          data
        }
        ... on Image {
          key
          url
          urlSmall
          meta {
            title
            source
            location
          }
        }
      }
    }
    image {
      key
      url
      meta {
        title
        location
      }
    }
  }
}`

export const SAVE_DIARY = `
mutation SaveDiary($diary: DiaryInput!){
  saveDiary(diary: $diary) {
    id
    key
    title
    created_at
  }
}`

export const IMAGES = `
query {
  images {
    key
    url
    url_small
    meta {
      source
      location
      title
    }
  }
}`

export const IMAGE = `
query FetchImage($key: String!){
  image(key: $key) {
    key
    url
    url_small
    meta {
      source
      location
      title
    }
  }
}`

export const SAVE_IMAGE = `
mutation SaveImage($image: ImageInput!, $image_file: String){
  saveImage(image:$image, image_file:$image_file) {
    key
    url
    url_small
    meta {
      title
      source
      location
    }
  }
}
`

export const DELETE_IMAGE = `
mutation DeleteImage($key: String!){
  deleteImage(key: $key) {
    key
    url
    url_small
    meta {
      source
      location
      title
    }
  }
}`